import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NoContentBox } from 'components/basic'
import { notify } from 'helpers'
import http from 'API/http'
import FileSaver from 'file-saver'

class BillingExport extends Component {
  async componentDidMount () {
    var id = this.props.match.params.id
    let err, res
    [err, res] = await http.get('2.3/billing/csv/' + id)
    if (err) notify.alert('', 'Export failed, try again', 'error')
    if (!err) {
      let blob = new window.Blob([res.data], { type: 'text/csv' })
      FileSaver.saveAs(blob, 'BillingExport' + id + '.csv')
    }
    window.location.hash = '/access'
  }
  render () {
    return (
      <div className='content-wrapper flexbox-absolute-center'>
        <NoContentBox icon='circle-o-notch fa-spin' text='Starting Download' />
      </div>
    )
  }
}
//eslint-disable-next-line
BillingExport = connect(state => state.siteReducer)(BillingExport)
export default BillingExport



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/2.3/core/billing.js